// extracted by mini-css-extract-plugin
export default {"main_div":"Searchbar_main_div__4Rvqz","input_box":"Searchbar_input_box__bnlla"};